const MOBILE_BREAKPOINT = 900;

// iOS Safari can leave the page visually shifted sideways after a
// `position: fixed` overlay portaled to <body> (ZipDetail / ForecastDayModal)
// is removed. Confirmed on real hardware: rotating the device
// landscape-then-portrait clears it, but a plain repaint (toggling `body`
// display off/on, tried first) does not — so this isn't a paint/compositing
// state a repaint can jog loose. Rotation is a genuine native resize event;
// what actually forces WebKit to redo its cached viewport geometry from JS,
// without an actual orientation change, is re-parsing the viewport <meta>
// tag — the same trick used for the well-documented "layout stuck after
// iOS keyboard closes" family of bugs. Toggling its `content` attribute and
// restoring it a frame later forces that recalculation.
export function forceRepaintAfterOverlayClose() {
  if (!window.matchMedia(`(max-width: ${MOBILE_BREAKPOINT}px)`).matches) return;
  const meta = document.querySelector('meta[name="viewport"]');
  if (!meta) return;
  const original = meta.getAttribute('content');
  meta.setAttribute('content', `${original}, maximum-scale=1`);
  requestAnimationFrame(() => {
    meta.setAttribute('content', original);
  });
}
